import React from 'react';
import OveragesManagement from '../OveragesManagement/OveragesManagement';
import { SubscriptionModel } from '@mm/state/model/SubscriptionModel';
import './TeamOveragesArea.pcss';
import { PlanInfo } from '@mm/state/helpers/billing-info-helpers';

type Props = {
  subscription: SubscriptionModel;
  planInfo: Partial<PlanInfo>;
};

export const TeamOveragesArea = (props: Props) => {
  const { subscription, planInfo } = props;

  const manualBuy = planInfo.isCustomTeam || planInfo.isLegacyTeamPlan;
  const text = manualBuy
    ? 'To continue sending SMS messages buy extra sends'
    : 'To continue sending messages, enable overage payments';

  const headerText = manualBuy
    ? 'SMS Credits Limit reached'
    : 'Credits Limit reached';
  return (
    <div className="team-overages-area">
      <div className="team-overages-area__left">
        <div className="team-overages-area__title">{headerText}</div>
        <div className="team-overages-area__sub-text">{text}</div>
      </div>

      {!manualBuy && (
        <OveragesManagement
          subscription={subscription}
          className="team-overages-area__enable-overages-button"
          textOverride="Enable Overage"
          hideQuestionIcon={true}
        />
      )}
    </div>
  );
};
